<template>
  <div>
    <el-dialog
      width="350px"
      top="39vh"
      title="请选择以下方式"
      :visible.sync="innerVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      @close="handleClose"
      v-loading="loading"
    >
      <div class="code">
        <div>
          <el-radio-group v-model="radio">
            <div>
              <el-radio label="1">捷算APP扫码</el-radio>
            </div>
            <div>
              <el-radio label="2">微信扫码</el-radio>
            </div>
          </el-radio-group>
          <div class="btn">
            <el-button class="previous-button" size="mini" @click="$emit('notify', false)">取消</el-button>
            <el-button class="nextstep-button" size="mini" @click="sumbit">确定</el-button>
          </div>
        </div>
        <div v-if="qrShow" class="qr" @click="qrShow = false">
          <div>
            <vue-qr :text="url" :size="180"></vue-qr>
            <div>{{ radio == 1 ? "请用“捷算”APP扫码确认" : "" }}</div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import VueQr from "vue-qr";
import * as secret from "@/utils/secret";
export default {
  components: {
    VueQr,
  },
  props: {
    identityFront: {
      type: String,
      default: "",
    },
    info: {
      type: Object,
    },
  },
  data() {
    return {
      innerVisible: true,
      radio: "1",
      url: "",
      qrShow: false,
      loading: false,
      interval: 5000,
      iv: "uvz37k2WLPZgUES4",
      key: "GoxZ3fT0Xnmc0yAu",
    };
  },
  methods: {
    handleClose() {
      this.$emit("notify", false);
      this.innerVisible = true;
    },
    sumbit() {
      this.loading = true;
      clearInterval(this.timer);
      if (this.radio == 1) {
        let params = {};
        if (this.identityFront) {
          params = {
            ...this.info,
            identityFront: this.identityFront,
          };
        }
        this.$api.user
          .jsQRCodeInfo(params)
          .then((res) => {
            if (res.code == 1000) {
              let data = res.data;
              this.qrShow = true;
              this.url = JSON.stringify(data);
              let decrypt = JSON.parse(
                secret.default.decrypt(data.data, this.key, this.iv)
              );
              this.callbackId = decrypt.callbackId;
              this.timer = setInterval(() => {
                this.jsCheckQRCode();
              }, this.interval);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        if (this.identityFront) {
          let params = {
            identityFront: this.identityFront,
          };
          this.$api.user
            .getFaceFirst(params)
            .then((res) => {
              if (res.code === 1000) {
                this.callbackId = res.data.callbackId;
                this.url = res.data.verifyFaceUrl;
                this.qrShow = true;
                this.timer = setInterval(() => {
                  this.checkQRCode();
                }, this.interval);
              }
            })
            .finally(() => {
              this.loading = false;
            });
          return;
        }
        this.$api.user
          .checkQRCodeValid({})
          .then((res) => {
            if (res.code === 1000) {
              this.callbackId = res.data.callbackId;
              this.url = res.data.verifyFaceUrl;
              this.qrShow = true;
              this.timer = setInterval(() => {
                this.checkQRCode();
              }, this.interval);
            }
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    checkQRCode() {
      if (!this.qrShow) {
        clearInterval(this.timer);
        return;
      }
      let params = {
        callbackId: this.callbackId,
      };
      this.$api.user.checkQRCode(params).then((res) => {
        if (res.data.status == 1) {
          clearInterval(this.timer);
          this.$message.success("FaceId验证成功");
          this.$emit("notify", true);
        } else if (res.data.status == 0) {
        } else {
          clearInterval(this.timer);
          this.$message.error("FaceId验证失败");
          this.$emit("notify", false);
        }
      });
    },
    jsCheckQRCode() {
      if (!this.qrShow) {
        clearInterval(this.timer);
        return;
      }
      let params = {
        callbackId: this.callbackId,
      };
      this.$api.user
        .checkJSQRCode(params)
        .then((res) => {
          if (res.data.status == 1) {
            this.$message.success("FaceId验证成功");
            this.$emit("notify", true);
            clearInterval(this.timer);
          } else if (res.data.status == 0) {
          } else {
            clearInterval(this.timer);
            this.$message.error("FaceId验证失败");
            this.$emit("notify", false);
          }
        })
        .catch(() => {
          clearInterval(this.timer);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.code {
  .el-radio-group {
    margin: 15px 0;
    > div {
      margin-bottom: 20px;
    }
  }
  .btn {
    display: flex;
    justify-content: center;
    margin: 0;
    button {
      width: 100px;
      height: 36px;
      border-radius: 2px;
      border: none;
      font-size: 14px;
      color: #fff;
      &.previous-button {
        background: linear-gradient(
          135deg,
          rgba(85, 96, 123, 1) 0%,
          rgba(57, 66, 89, 1) 100%
        );
      }
      &.nextstep-button {
        margin-left: 20px;
        background: linear-gradient(
          135deg,
          rgba(255, 112, 103, 1) 0%,
          rgba(239, 81, 71, 1) 100%
        );
      }
    }
  }
  .qr {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000000, $alpha: 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    > div {
      text-align: center;
      font-size: 14px;
      color: #fff;
      div {
        margin-top: 10px;
      }
    }
  }
}
</style>